module.exports = __webpack_public_path__ + "static/16-3a1f1a2a6ece3fbf52bc5fa86bf93a54.jpg";